// extracted by mini-css-extract-plugin
export default {"neonTitle":"neonTitle_neonTitle__wsKf+","titleGlow":"neonTitle_titleGlow__1j2o+","scroll":"neonTitle_scroll__eZRqz"};